import React, { Component } from "react";
import { Icon, Avatar, Divider, Tooltip, Select, message } from "antd";
import F from "../../Functions";
import ClassicCar from "../Wizard/parts/images/new/classic_car.svg";
import ClassicCarNew from "../Wizard/parts/images/new/classic_car_new.svg";
import RV from "../Wizard/parts/images/new/rv.svg";
import Boat from "../Wizard/parts/images/new/boat.svg";
import Motorcycle from "../Wizard/parts/images/new/motor_cycle.svg";
import Drone from "../Wizard/parts/images/new/drone.svg";
import GolfCart from "../Wizard/parts/images/new/golf_cart.svg";
import Watercraft from "../Wizard/parts/images/new/water_craft.svg";
import Snowmobile from "../Wizard/parts/images/new/snowmobile.svg";
import OffRoad from "../Wizard/parts/images/new/atv.svg";
import Other from "../Wizard/parts/images/new/other.svg";
import SecondaryHome from "../Wizard/parts/images/new/homeowners.svg";
import SecondaryHomeBlue from "../Wizard/parts/images/new/homeowners_new.svg";
import MFGHome from "../Wizard/parts/images/new/mfg.svg";
import Condominium from "../Wizard/parts/images/new/condominium.svg";
import Landlord from "../Wizard/parts/images/bfile-landlord.svg";
import Renter from "../Wizard/parts/images/bfile-renter.svg";
import VacantProperty from "../Wizard/parts/images/new/vacant-land.svg";
import Umbrella from "../Wizard/parts/images/bfile-umbrella.svg";
import Auto from "../Wizard/parts/images/bfile-classic_car.svg";
import Home from "../Wizard/parts/images/bfile-homeowners.svg";
import Insurance from "../Wizard/parts/images/bfile-insurance.svg";
import Annuity from "../Wizard/parts/images/bfile-annuties.svg";
import MutualFunds from "../Wizard/parts/images/bfile-currency.svg";
import IRAs from "../Wizard/parts/images/bfile-ira.svg";
import Annuities from "../Wizard/parts/images/bfile-annuties.svg";
import SavingsAccounts from "../Wizard/parts/images/bfile-savings-account.svg";
import CDs from "../Wizard/parts/images/bfile-cd.svg";
import BrokerageAccounts from "../Wizard/parts/images/bfile-brokerage-account.svg";
import Cryptocurrency from "../Wizard/parts/images/icon-crypto.svg";
import None from "../Wizard/parts/images/bfile-no.svg";
import Icon401K from "../Wizard/parts/images/new/401.svg";
import Icon403b from "../Wizard/parts/images/new/403b.svg";
import Icon457 from "../Wizard/parts/images/new/457.svg";
import IconPensionFund from "../Wizard/parts/images/new/pensionfund.svg";
import IconNo from "../Wizard/parts/images/bfile-no.svg";
import HomeIcon from "./images/new/cloud-computing 1.svg";
import UmbrellaLimitIcon from "../Wizard/parts/images/umbrella_new.svg";
import LifeInsuranceIcon from "../Wizard/parts/images/life-insurance_new.svg";
import { Translate } from "react-translated";
import moment from "moment";
import ReadMore from "../../components/read-more";
import { BFILE_RECYCLE_IS_SCEDULED_FOR, BFILE_WILL_NOT_REAPPEAR_FOR_REVIEW, CURRENT_YEAR_REVIEW_ACTIVE_MONTH_IS, FOLLOW_UP_ACTIVE_MONTH_UPDATED_SUCCESSFULLY, get_label_from_value, get_sub_type_of_call_from_label, NO_FOLLOW_UP, NO_REVIEW, REVIEW, REVIEW_ACTIVE_MONTH_UPDATED_SUCCESSFULLY } from "../../utils/Constants";

// new icons 
import NotePadIcon from "./images/new/notepad 1.svg";
import processIcon from "./images/new/process 1.svg";
import workerIcon from "./images/new/worker 1.svg";
import moneyBagIcon from "./images/new/money-bag 1.svg";
import garageIcon from "./images/new/garage 1.svg";
import financialIcon from "./images/new/financial 1.svg";
import CheckMark from "./images/new/check-mark 1.svg";
import axios from "../../api";
import { UPDATE_ACTIVE_FOLLOW_UP_MONTH, UPDATE_ACTIVE_REVIEW_MONTH, UPDATE_RS_EFFECTIVE_DATE } from "../../utils/Api_enums";
import { getAutoAndHomeValue } from "../../components/print-pdf/helpers";

const parseLiabilityLimits = (value) => {
  if (!value) return {};
  if (typeof value === "object") return value;
  try {
    return JSON.parse(value);
  } catch (error) {
    return {};
  }
};

const formatCoverageLimit = (value) => {
  if (value == null || value === "") return "-";

  const normalizedValue = String(value).trim();
  if (/^\$?nan$/i.test(normalizedValue)) return "-";

  return normalizedValue
    .split("/")
    .map((part) => {
      if (/^\$?nan$/i.test(part.trim())) return "-";
      if (part.includes("$")) return part;
      const numericValue = Number(part.replace(/,/g, "").trim());
      if (Number.isNaN(numericValue)) return "-";
      return F.dollar_format(numericValue < 1000 ? numericValue * 1000 : numericValue);
    })
    .join("/");
};

const calculateRecommendedUmbrellaLimit = (value) => {
  const liabilityValue = Number(String(value || 0).replace(/[$,]/g, ""));

  if (liabilityValue < 500000) return "";
  if (liabilityValue <= 1249999) return 1000000;
  if (liabilityValue <= 2249999) return 2000000;
  if (liabilityValue <= 3249999) return 3000000;
  if (liabilityValue <= 4249999) return 4000000;
  if (liabilityValue <= 5249999) return 5000000;
  if (liabilityValue <= 6249999) return 6000000;
  if (liabilityValue <= 7249999) return 7000000;
  if (liabilityValue <= 8249999) return 8000000;
  if (liabilityValue <= 9249999) return 9000000;
  return 10000000;
};

const init = (bfile, agency_owner_details, onMonthChangeCallback,
  reviewActiveMonthDropDownStatus,
  previousCallAttemptCount
) => {

  // Get userType from localStorage at the very start
  let userType = "";
  try {
    const zustandStorage = localStorage.getItem("zustand-storage");
    if (zustandStorage) {
      const parsed = JSON.parse(zustandStorage);
      userType =
        (parsed &&
          parsed.state &&
          parsed.state.userInfo &&
          parsed.state.userInfo.user_type) ||
        (parsed && parsed.state && parsed.state.userType) ||
        "";
    }
  } catch (e) {
    userType = "";
  }
  F.log("Bfile init = > ", JSON.stringify(bfile));
  let status_data = [];
  let life_stage_data = [];
  let financial_recommendations_data = [];
  let assets_account_data = [];
  let employment_data = [];
  let household_total_assets_data = [];
  let pc_cross_sell_opp_data = [];
  let items_sold_data = [];
  let renewal_policies_data = [];

  const months = F.getMonths();
  const review_months = [
    ...months,
    { id: null, name: 'No Review' }
  ];
  const follow_up_months = [
    ...months,
    { id: null, name: 'No Follow-Up' }
  ];

  bfile.onboarding_attempts = 0;
  bfile.onboarding_reached = "";
  bfile.financial_attempts = 0;
  bfile.financial_reached = "";

  if (bfile.questions.length > 0) {
    const ea_wizard = bfile.questions[0];
    if (ea_wizard.call_attempts !== "" && ea_wizard.call_attempts !== null) {
      bfile.onboarding_attempts = ea_wizard.call_attempts;
    }
    if (ea_wizard.call_reached_toggle === "1") {
      bfile.onboarding_reached = "Yes";
    } else {
      bfile.onboarding_reached = "No";
    }
  }

  if (bfile.financial_conversion.length > 0) {
    const financial_wizard = bfile.financial_conversion[0];
    if (
      financial_wizard.call_attempts !== "" &&
      financial_wizard.call_attempts !== null
    ) {
      bfile.financial_attempts = financial_wizard.call_attempts;
    }
    if (financial_wizard.call_reached_toggle === "1") {
      bfile.financial_reached = "Yes";
      bfile.financial_attempts++;
    } else {
      bfile.financial_reached = "No";
    }
  }

  bfile.life_insurance_types = [];
  if (
    bfile.home_mortgage_protection_policy !== null &&
    bfile.home_mortgage_protection_policy !== ""
  ) {
    bfile.life_insurance_types = JSON.parse(
      bfile.home_mortgage_protection_policy
    );
  }

  bfile.asset_accounts_obj = [];
  bfile.asset_accounts_obj_spouse = [];

  if (bfile.asset_accounts !== null && bfile.asset_accounts !== "") {
    bfile.asset_accounts_obj = JSON.parse(bfile.asset_accounts);
  }

  if (
    bfile.asset_accounts_spouse !== null &&
    bfile.asset_accounts_spouse !== ""
  ) {
    bfile.asset_accounts_obj_spouse = JSON.parse(bfile.asset_accounts_spouse);
  }

  bfile.life_stage = F.bfile_life_stage(bfile, agency_owner_details);

  if (bfile && bfile.agency && bfile.agency.name !== "") {
    status_data.push({
      name: <Translate text={`Agency`} />,
      value: bfile.agency.name
    });
  }
  if (bfile && bfile.agency && bfile.agency.address !== "") {
    status_data.push({
      name: <Translate text={`Agency Address`} />,
      value: bfile.agency.address
    });
  }
  // status_data.push({
  //   name: <Translate text={`Follow-Up Call Attempts (Not Reached)`} />,
  //   value: bfile.onboarding_attempts || "0"
  // });
  if (
    bfile.onboarding_reached !== null &&
    bfile.onboarding_reached !== "" &&
    bfile.onboarding_reached !== "No"
  ) {
    status_data.push({
      name: <Translate text={`Follow-Up Call Reached`} />,
      value: (
        <Translate
          text={bfile.onboarding_reached ? bfile.onboarding_reached : ""}
        />
      )
    });
  }
  // if (bfile.financial_attempts !== "") {
  //   status_data.push({
  //     name: (
  //       <Translate text={`Life & Retirement Call Attempts (Not Reached)`} />
  //     ),
  //     value: bfile.financial_attempts + ""
  //   });
  // }
  if (bfile.financial_reached !== "") {
    status_data.push({
      name: <Translate text={`Life & Retirement Call Reached`} />,
      value: (
        <Translate
          text={bfile.financial_reached ? bfile.financial_reached : ""}
        />
      )
    });
  }
  /*status_data.push({
        name: <Translate text={`Thank You/Life & Retirement Call`} />,
        value: (bfile.is_onboarded === 1 && bfile.questions.length > 0 && bfile.questions[0].financial_conversion_action !== null) ? 'Yes' : 'No'
    });*/

  const type_of_call = F.getTypeOfCall(bfile);

  if (type_of_call.length > 0) {
    status_data.push({
      name: <Translate text={`type_of_call`} />,
      value: type_of_call
    });
  }

  const sub_type_of_call = F.getSubTypeOfCall(bfile);

  if (sub_type_of_call.length > 0) {
    status_data.push({
      name: <Translate text={`sub_type_of_call`} />,
      value: (<div style={{ width: "100%" }}>
        <Tooltip title={get_label_from_value(bfile.sub_type_of_call, 'label', bfile.type_of_call)}>
          <div style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
            {get_label_from_value(bfile.sub_type_of_call, 'label', bfile.type_of_call)}
          </div>
        </Tooltip>
      </div>)
    });
  }

  // Farm Bureau Number
  if (bfile.farm_bureau_number !== null && bfile.farm_bureau_number !== "") {
    status_data.push({
      name: <Translate text={`farm_bureau_number`} />,
      value: F.getFarmBureauNumber(bfile)
    });
  }


  if (previousCallAttemptCount !== null && previousCallAttemptCount !== undefined) {
    status_data.push({
      name: <Translate text={`Previous Call Attempt Count`} />,
      value: previousCallAttemptCount
    })
  }


  if (bfile.user) {
    status_data.push({
      name: <Translate text={`B File Creator`} />,
      value: bfile.user.first_name + " " + bfile.user.last_name
    });
  }
  if (bfile.onboarding_id) {
    status_data.push({
      name: <Translate text={`Follow-Up Specialist`} />,
      value:
        bfile.onboarding_user.first_name + " " + bfile.onboarding_user.last_name
    });
  }
  // if (bfile.financial_id) {
  //   status_data.push({
  //     name: <Translate text={`Financial Specialist`} />,
  //     value:
  //       bfile.financial_user.first_name + " " + bfile.financial_user.last_name,
  //   });
  // }
  if (bfile.rs_appointment_date !== null && bfile.rs_appointment_date !== "") {
    status_data.push({
      name: <Translate text={`Appointment Date`} />,
      value: moment(new Date(bfile.rs_appointment_date)).format(
        "MM/DD/YYYY"
      )
    });
  }
  if (bfile.rs_policy_type !== null && bfile.rs_policy_type !== "") {
    status_data.push({
      name: <Translate text={`Policy Type`} />,
      value: bfile.rs_policy_type
    });
  }


  let defaultMonthFS = "";
  if (reviewActiveMonthDropDownStatus) {
    if (reviewActiveMonthDropDownStatus.followup_month) {
      defaultMonthFS = F.getMonthNames()[(reviewActiveMonthDropDownStatus.followup_month) - 1];
      console.log("defaultMonthFS", defaultMonthFS)
    } else {
      defaultMonthFS = NO_FOLLOW_UP
    }
  }



  if (reviewActiveMonthDropDownStatus &&
    !reviewActiveMonthDropDownStatus.isFsMonthDropDownHidden) {
    status_data.push({
      className: "profile-status-follow-up-active-month",
      name: <Translate text={`Follow-Up Active Month`} />,
      value: (
        <span style={{ display: "block", minWidth: 0, width: "100%" }}>
          {(userType === "EA" || userType === "LSP") ? (
            <Select
              value={defaultMonthFS}
              className="custom-rounded-select"
              style={{ width: "100%", maxWidth: 180, borderRadius: '20px' }}
              onChange={(e) => handleMonthChangeFS(e)}
            >
              {follow_up_months.map((month) => (
                <Select.Option key={month.id} value={month.id}>
                  {month.name}
                </Select.Option>
              ))}
            </Select>
          ) : (
            <span style={{ fontWeight: 500, fontSize: 16, marginRight: 8 }}>
              {defaultMonthFS}
            </span>
          )}

          {/* <Tooltip
            title={`${CURRENT_YEAR_REVIEW_ACTIVE_MONTH_IS} ${defaultMonthRS === NO_REVIEW
              ? `${NO_REVIEW}. ${BFILE_WILL_NOT_REAPPEAR_FOR_REVIEW}`
              : `${getMonthFromDate(reviewActiveMonthDropDownStatus.rs_effective_date)}
                ${getYearFromDate(reviewActiveMonthDropDownStatus.rs_effective_date)}. ${BFILE_RECYCLE_IS_SCEDULED_FOR}
                 ${defaultMonthRS} ${Number(getYearFromDate(reviewActiveMonthDropDownStatus.rs_effective_date)) + 1
              }`
              }`}
          >

            <Icon type="info-circle" style={{ color: '#1890ff', cursor: 'pointer' }} />
          </Tooltip> */}
        </span>
      )

      // name: <Translate text={`Follow-Up Active Call Date`} />,
      // value: moment(new Date(bfile.bfile_sub[0].fs_effective_date)).format("MM/DD/YYYY")
    });
  }
  // if (bfile && bfile.bfile_sub && bfile.bfile_sub.length > 0 &&
  //   bfile.bfile_sub[0].fs_expiration_date) {
  //   status_data.push({
  //     name: <Translate text={`Follow-Up Schedule-by Date`} />,
  //     value: moment(new Date(bfile.bfile_sub[0].fs_expiration_date)).format("MM/DD/YYYY")
  //   });
  // }


  const getMonthFromDate = (dateString) => {
    if (!dateString) return NO_REVIEW;
    return moment(dateString).format("MMMM");
  };

  const getYearFromDate = (dateString) => {
    if (!dateString) return NO_REVIEW;
    return moment(dateString).format("YYYY");
  }

  let defaultMonthRS = "";
  if (reviewActiveMonthDropDownStatus) {
    if (reviewActiveMonthDropDownStatus.review_month) {
      defaultMonthRS = F.getMonthNames()[(reviewActiveMonthDropDownStatus.review_month) - 1];
    } else {
      defaultMonthRS = NO_REVIEW
    }
  }


  // if (
  //   bfile &&
  //   bfile.bfile_sub &&
  //   Array.isArray(bfile.bfile_sub) &&
  //   bfile.bfile_sub.length > 0 &&
  //   bfile.bfile_sub[0].rs_review_month
  // ) {
  //   const monthIndex = bfile.bfile_sub[0].rs_review_month - 1;
  //   if (monthIndex >= 0 && monthIndex < 12) {
  //     defaultMonthRS = F.getMonthNames()[monthIndex];
  //     // console.log(defaultMonthRS)
  //   }
  // } else {
  //   defaultMonthRS = NO_REVIEW
  // }

  // getMonthFromDate(bfile.rs_effective_date);

  const handleMonthChangeFS = async (value) => {
    const payload = {
      fs_month: !value ? null : Number(value),
    }
    try {
      const res = await axios.put(UPDATE_ACTIVE_FOLLOW_UP_MONTH(bfile.id), payload);
      message.success(FOLLOW_UP_ACTIVE_MONTH_UPDATED_SUCCESSFULLY);
      if (typeof onMonthChangeCallback === "function") {
        onMonthChangeCallback();
      }
    } catch (error) {
      let errorMsg = "Failed to update month";
      if (error && error.response && error.response.data && error.response.data.error) {
        errorMsg = error.response.data.error;
      }
      console.error(error);
      message.error(errorMsg);
    }


  }


  const handleMonthChangeRS = async (value) => {
    const payload = {
      rs_review_month: !value ? null : Number(value),
    };
    try {
      const res = await axios.put(UPDATE_ACTIVE_REVIEW_MONTH(bfile.id), payload);
      // console.log(res)
      message.success(REVIEW_ACTIVE_MONTH_UPDATED_SUCCESSFULLY);
      if (typeof onMonthChangeCallback === "function") {
        onMonthChangeCallback();
      }
    } catch (error) {
      let errorMsg = "Failed to update month";
      if (error && error.response && error.response.data && error.response.data.error) {
        errorMsg = error.response.data.error;
      }
      console.error(error);
      message.error(errorMsg);
    }

  };


  if (reviewActiveMonthDropDownStatus &&
    !reviewActiveMonthDropDownStatus.isReviewMonthDropDownHidden) {
    status_data.push({
      className: "profile-status-follow-up-active-month",
      name: (
        <span>
          <Translate text={`Review Active Month`} />{' '}
        </span>
      )
      ,
      value: (
        <span style={{ display: "block", minWidth: 0, width: "100%" }}>
          {(userType === "EA" || userType === "LSP") ? (
            <Select
              value={defaultMonthRS}
              className="custom-rounded-select"
              style={{ width: "100%", maxWidth: 180, borderRadius: '20px' }}
              onChange={(e) => handleMonthChangeRS(e)}
            >
              {review_months.map((month) => (
                <Select.Option key={month.id} value={month.id}>
                  {month.name}
                </Select.Option>
              ))}
            </Select>
          ) : (
            <span style={{ fontWeight: 500, fontSize: 16, marginRight: 8 }}>
              {defaultMonthRS}
            </span>
          )}

          {/* <Tooltip
            title={`${CURRENT_YEAR_REVIEW_ACTIVE_MONTH_IS} ${defaultMonthRS === NO_REVIEW
              ? `${NO_REVIEW}. ${BFILE_WILL_NOT_REAPPEAR_FOR_REVIEW}`
              : `${getMonthFromDate(reviewActiveMonthDropDownStatus.rs_effective_date)} 
                ${getYearFromDate(reviewActiveMonthDropDownStatus.rs_effective_date)}. ${BFILE_RECYCLE_IS_SCEDULED_FOR}
                 ${defaultMonthRS} ${Number(getYearFromDate(reviewActiveMonthDropDownStatus.rs_effective_date)) + 1
              }`
              }`}
          >

            <Icon type="info-circle" style={{ color: '#1890ff', cursor: 'pointer' }} />
          </Tooltip> */}
        </span>
      )
    });
  }



  F.log("88888", bfile);
  if (bfile.birthday !== null && bfile.birthday !== "" && (bfile.user.carrier || (agency_owner_details && agency_owner_details.carrier)) !== "Country Financial") {
    F.log("88888", F.bfile_get_ages(bfile).join("/"));
    life_stage_data.push({
      name: <Translate text={`Ages`} />,
      value: F.bfile_get_ages(bfile).join("/")
    });
  }
  if (bfile.children !== null && bfile.children !== "" && bfile.children > 0) {
    life_stage_data.push({
      name: <Translate text={`Number of Children`} />,
      value: bfile.children + ""
    });
  }
  if (bfile.home_mortgage_toggle === "1") {
    life_stage_data.push({
      name: <Translate text={`Primary Mortgage Balance`} />,
      value: bfile.home_mortgage
    });
  }
  if (bfile.secondary_home_mortgage_toggle === "1") {
    life_stage_data.push({
      name: <Translate text={`Total Additional Mortgage Balances`} />,
      value: bfile.secondary_home_mortgage
    });
  }
  if (bfile.home_mortgage_protection_toggle === "0") {
    life_stage_data.push({
      name: <Translate text={`Life Insurance`} />,
      value: <Translate text={`No Life Insurance`} />
    });
  }
  F.log(
    'bfile.life_insurance_types.join(", ")',
    bfile.life_insurance_types.join(", ")
  );
  if (bfile.home_mortgage_protection_toggle === "1") {
    life_stage_data.push({
      name: <Translate text={`Life Insurance Owned`} />,
      value: (
        <div>
          {typeof bfile.life_insurance_types !== "undefined" ? (
            <p>
              <span className="blackText">Types:</span>{" "}
              {bfile.life_insurance_types.join(", ")}
            </p>
          ) : null}
          {bfile.home_mortgage_protection_benefit !== "" ? (
            <p>
              <span className="blackText">
                <Translate text={`Amount`} />:
              </span>{" "}
              {bfile.home_mortgage_protection_benefit}
            </p>
          ) : null}
        </div>
      )
    });
  }
  if (
    typeof bfile.life_stage.title !== "undefined" &&
    bfile.life_stage.title !== ""
  ) {
    life_stage_data.push({
      name: "",
      value: (
        <div>
          <h3>
            <Avatar src={bfile.life_stage.thumb} style={{ marginRight: 10 }} />
            <Translate
              text={bfile.life_stage.title ? bfile.life_stage.title : ""}
            />
          </h3>
          <p>
            <Translate
              text={bfile.life_stage.desc ? bfile.life_stage.desc : ""}
            />
          </p>
        </div>
      )
    });
  }

  if (
    bfile.asset_401k_accounts !== "" &&
    bfile.asset_preservation_value !== null &&
    bfile.asset_preservation_value !== ""
  ) {
    F.log("bfile.asset_401k_accounts", bfile.asset_401k_accounts);
    F.log("bfile.asset_401k_accounts", asset_401k_accounts);
    let asset_401k_accounts = [];

    try {
      if (bfile.asset_401k_accounts) {
        // Ensure it's a string before parsing
        asset_401k_accounts = typeof bfile.asset_401k_accounts === "string"
          ? JSON.parse(bfile.asset_401k_accounts)
          : bfile.asset_401k_accounts;
      }
    } catch (error) {
      console.error("Error parsing asset_401k_accounts:", error);
      asset_401k_accounts = [];
    }

    F.log("bfile.asset_401k_accounts", asset_401k_accounts);
    if (asset_401k_accounts.length > 0) {
      assets_account_data.push({
        // name: <Translate text={asset_401k_accounts.join(" & ") + ` - Value`} />,
        name: (
          <React.Fragment>
            <Translate text={`Retirement`} />
            <br />

            <div className="icon-container-flex">
              {asset_401k_accounts.map((item, i) => {
                let Icon;
                if (item === "IRA") Icon = IRAs;
                if (item === "IRA's") Icon = IRAs;
                if (item === "Annuities") Icon = Annuities;
                if (item === "Savings Account") Icon = SavingsAccounts;
                if (item === "Savings Accounts") Icon = SavingsAccounts;
                if (item === "CDs") Icon = CDs;
                if (item === "CD's") Icon = CDs;
                if (item === "Brokerage Accounts") Icon = BrokerageAccounts;
                if (item === "Cryptocurrency") Icon = Cryptocurrency;
                if (item === "None") Icon = None;
                if (item === "401 (k)") Icon = Icon401K;
                if (item === "401k") Icon = Icon401K;
                if (item === "403 (b)") Icon = Icon403b;
                if (item === "403b") Icon = Icon403b;
                if (item === "457") Icon = Icon457;
                if (item === "Pension Fund") Icon = IconPensionFund;
                if (item === "No") Icon = IconNo;
                return (
                  <div key={i} className="border-color-164897 ">
                    <img
                      src={Icon}
                      alt={item}
                      style={{
                        width: 16,
                        opacity: 0.6,
                        marginRight: 10,
                        verticalAlign: "middle",
                      }}
                    />
                    <Translate text={item ? item : ""} />
                  </div>
                );
              })}
              {/* <Divider /> */}
            </div>
          </React.Fragment>
        ),
        value: bfile.asset_preservation_value
      });
    }
  }

  if (
    bfile.asset_401k_accounts_spouse !== "" &&
    bfile.asset_preservation_value_spouse !== null &&
    bfile.asset_preservation_value_spouse !== ""
  ) {
    let asset_401k_accounts_spouse = [];

    try {
      if (bfile.asset_401k_accounts_spouse) {
        // Ensure it's a string before parsing
        asset_401k_accounts_spouse = typeof bfile.asset_401k_accounts_spouse === "string"
          ? JSON.parse(bfile.asset_401k_accounts_spouse)
          : bfile.asset_401k_accounts_spouse;
      }
    } catch (error) {
      console.error("Error parsing asset_401k_accounts:", error);
      asset_401k_accounts_spouse = [];
    }

    F.log("bfile.asset_401k_accounts", asset_401k_accounts_spouse);

    if (asset_401k_accounts_spouse.length > 0) {
      assets_account_data.push({
        // name: (
        //   <Translate
        //     text={
        //       `Spouse - ` + asset_401k_accounts_spouse.join(" & ") + ` - Value`
        //     }
        //   />
        // ),
        name: (
          <React.Fragment>
            <Translate text={`Spouse Retirement`} />
            <br />
            <div className="icon-container-flex">
              {asset_401k_accounts_spouse.map((item, i) => {
                let Icon;
                if (item === "IRA") Icon = IRAs;
                if (item === "IRA's") Icon = IRAs;
                if (item === "Annuities") Icon = Annuities;
                if (item === "Savings Account") Icon = SavingsAccounts;
                if (item === "Savings Accounts") Icon = SavingsAccounts;
                if (item === "CDs") Icon = CDs;
                if (item === "CD's") Icon = CDs;
                if (item === "Brokerage Accounts") Icon = BrokerageAccounts;
                if (item === "Cryptocurrency") Icon = Cryptocurrency;
                if (item === "None") Icon = None;
                if (item === "401 (k)") Icon = Icon401K;
                if (item === "401k") Icon = Icon401K;
                if (item === "403 (b)") Icon = Icon403b;
                if (item === "403b") Icon = Icon403b;
                if (item === "457") Icon = Icon457;
                if (item === "Pension Fund") Icon = IconPensionFund;
                if (item === "No") Icon = IconNo;
                return (
                  <div key={i} className="border-color-164897 ">
                    <img
                      src={Icon}
                      alt={item}
                      style={{
                        width: 16,
                        opacity: 0.6,
                        marginRight: 10,
                        verticalAlign: "middle",
                      }}
                    />
                    <Translate text={item ? item : ""} />
                  </div>
                );
              })}
              {/* <Divider /> */}
            </div>
          </React.Fragment>
        ),
        value: bfile.asset_preservation_value_spouse,
      });
    }
  }

  if (
    bfile.employed_anual_income !== null &&
    bfile.employed_anual_income !== "" &&
    bfile.employed_anual_income !== "$0"
  ) {
    assets_account_data.push({
      name: <Translate text={`Household Income`} />,
      value: bfile.employed_anual_income
    });
  }
  if (
    bfile.employed_anual_income_spouse !== null &&
    bfile.employed_anual_income_spouse !== "" &&
    bfile.employed_anual_income_spouse !== "$0"
  ) {
    assets_account_data.push({
      name: <Translate text={`Spouse - Household Income`} />,
      value: bfile.employed_anual_income_spouse
    });
  }
  // assets account yes no 
  // assets_account_data.push({
  //   name: <Translate text={`Asset Accounts`} />,
  //   value: (
  //     <div>
  //       {bfile.asset_accounts_obj.length === 0 ||
  //         (bfile.asset_accounts_obj.length === 1 &&
  //           bfile.asset_accounts_obj.indexOf("None") >= 0) ? (
  //         <span>
  //           <Translate text={`No`} />
  //         </span>
  //       ) : (
  //         <div className="blackText">
  //           <Translate text={`Yes`} />
  //           <img src={CheckMark} width={20} style={{paddingLeft:"5px"}}/>
  //         </div>
  //       )}        
  //     </div>
  //   )
  // });
  // assets account icons and total value
  if (bfile.asset_accounts_obj.length > 0 &&
    bfile.asset_accounts_obj.indexOf("None") < 0) {

    assets_account_data.push({
      // name: "",
      name: (
        <div >
          {bfile.asset_accounts_obj.length > 0 &&
            bfile.asset_accounts_obj.indexOf("None") < 0 ? (
            <React.Fragment>
              <Translate text={`Assets`} />
              <br />
              <div className="icon-container-flex">
                {bfile.asset_accounts_obj.map((item, i) => {
                  let Icon;
                  if (item === "IRA") Icon = IRAs;
                  if (item === "IRA's") Icon = IRAs;
                  if (item === "Annuities") Icon = Annuities;
                  if (item === "Savings Account") Icon = SavingsAccounts;
                  if (item === "Savings Accounts") Icon = SavingsAccounts;
                  if (item === "CDs") Icon = CDs;
                  if (item === "CD's") Icon = CDs;
                  if (item === "Brokerage Accounts") Icon = BrokerageAccounts;
                  if (item === "Cryptocurrency") Icon = Cryptocurrency;
                  if (item === "None") Icon = None;
                  if (item === "401 (k)") Icon = Icon401K;
                  if (item === "401k") Icon = Icon401K;
                  if (item === "403 (b)") Icon = Icon403b;
                  if (item === "403b") Icon = Icon403b;
                  if (item === "457") Icon = Icon457;
                  if (item === "Pension Fund") Icon = IconPensionFund;
                  if (item === "No") Icon = IconNo;
                  return (
                    <div key={i} className="border-color-164897 ">
                      <img
                        src={Icon}
                        alt={item}
                        style={{
                          width: 16,
                          opacity: 0.6,
                          marginRight: 10,
                          verticalAlign: "middle"
                        }}
                      />
                      <Translate text={item ? item : ""} />
                    </div>
                  );
                })}
                {/* <Divider /> */}
              </div>
            </React.Fragment>
          ) : null}
        </div>
      ),
      value: (
        <div>
          {bfile.asset_total_value !== null &&
            bfile.asset_total_value !== "" &&
            bfile.asset_accounts_obj.length > 0 &&
            bfile.asset_accounts_obj.indexOf("None") < 0 ? (
            <div>
              {bfile.asset_total_value}
            </div>
          ) : null}
        </div>
      ),
    });
  }
  // total value of assets account
  // if(bfile.asset_total_value !== null &&
  //   bfile.asset_total_value !== "" &&
  //   bfile.asset_accounts_obj.length > 0 &&
  //   bfile.asset_accounts_obj.indexOf("None") < 0){
  //     assets_account_data.push({
  //       name: <span className="color-164897">
  //       <Translate text={`Total Value of Asset Account's:-`} />
  //       </span>,
  //       value: (
  //         <div>
  //           {bfile.asset_total_value !== null &&
  //           bfile.asset_total_value !== "" &&
  //           bfile.asset_accounts_obj.length > 0 &&
  //           bfile.asset_accounts_obj.indexOf("None") < 0 ? (
  //           <div>
  //             {bfile.asset_total_value}
  //           </div>
  //         ) : null}
  //         </div>
  //       )
  //     });
  //   }





  // -------------------------------------------------------------------

  //spouse asset accounts info
  // assets_account_data.push({
  //   name: <Translate text={`Spouse - Asset Accounts`} />,
  //   value: (
  //     <div>
  //       {bfile.asset_accounts_obj_spouse.length === 0 ||
  //         (bfile.asset_accounts_obj_spouse.length === 1 &&
  //           bfile.asset_accounts_obj_spouse.indexOf("None") >= 0) ? (
  //         <span>
  //           <Translate text={`No`} />
  //         </span>
  //       ) : (
  //         <div className="blackText">
  //           <Translate text={`Yes`} />
  //           <img src={CheckMark} width={20} style={{paddingLeft:"5px"}}/>
  //         </div>
  //       )}

  //     </div>
  //   )
  // });

  //spouse asset icon and total value
  if (
    bfile.asset_accounts_obj_spouse &&
    bfile.asset_accounts_obj_spouse.length > 0 &&
    bfile.asset_accounts_obj_spouse.indexOf("None") < 0
  ) {
    assets_account_data.push({
      // name: "",
      name: (
        <div>
          {bfile.asset_accounts_obj_spouse &&
            bfile.asset_accounts_obj_spouse.length > 0 &&
            bfile.asset_accounts_obj_spouse.indexOf("None") < 0 && (
              <React.Fragment>
                <Translate text={`Spouse Assets`} />
                <br />
                <div className="icon-container-flex">
                  {bfile.asset_accounts_obj_spouse &&
                    bfile.asset_accounts_obj_spouse.map((item, i) => {
                      let Icon;
                      if (item === "IRA") Icon = IRAs;
                      if (item === "IRA's") Icon = IRAs;
                      if (item === "Annuities") Icon = Annuities;
                      if (item === "Savings Account") Icon = SavingsAccounts;
                      if (item === "Savings Accounts") Icon = SavingsAccounts;
                      if (item === "CDs") Icon = CDs;
                      if (item === "CD's") Icon = CDs;
                      if (item === "Brokerage Accounts")
                        Icon = BrokerageAccounts;
                      if (item === "Cryptocurrency") Icon = Cryptocurrency;
                      if (item === "None") Icon = None;
                      if (item === "401 (k)") Icon = Icon401K;
                      if (item === "401k") Icon = Icon401K;
                      if (item === "403 (b)") Icon = Icon403b;
                      if (item === "403b") Icon = Icon403b;
                      if (item === "457") Icon = Icon457;
                      if (item === "Pension Fund") Icon = IconPensionFund;
                      if (item === "No") Icon = IconNo;
                      return (
                        <div
                          key={i}
                          className="border-color-164897 "
                          style={{ display: "inline" }}
                        >
                          <img
                            src={Icon}
                            alt={item}
                            style={{
                              width: 16,
                              opacity: 0.6,
                              marginRight: 10,
                              verticalAlign: "middle",
                            }}
                          />
                          <Translate text={item ? item : ""} />
                        </div>
                      );
                    })}
                </div>
              </React.Fragment>
            )}
        </div>
      ),
      value: (
        <div>
          {bfile.asset_total_value_spouse !== null &&
            bfile.asset_total_value_spouse !== "" &&
            bfile.asset_accounts_obj_spouse.length > 0 &&
            bfile.asset_accounts_obj_spouse.indexOf("None") < 0 ? (
            <div>{bfile.asset_total_value_spouse}</div>
          ) : null}
        </div>
      ),
    });
  }

  // if(bfile.asset_total_value_spouse !== null &&
  //   bfile.asset_total_value_spouse !== "" &&
  //   bfile.asset_accounts_obj_spouse.length > 0){

  //     assets_account_data.push({
  //       name: <span className="color-164897" >
  //       <Translate text={`Total Value of Spouse's Asset Account's:-`} />
  //     </span>,
  //       value: (
  //         <div>
  //            {bfile.asset_total_value_spouse !== null &&
  //             bfile.asset_total_value_spouse !== "" &&
  //             bfile.asset_accounts_obj_spouse.length > 0 &&
  //             bfile.asset_accounts_obj_spouse.indexOf("None") < 0 ? (
  //             <div>
  //               {bfile.asset_total_value_spouse}
  //             </div>
  //           ) : null}
  //         </div>
  //       )
  //     });
  //   }

  if (
    bfile.asset_401k_accounts !== "" &&
    bfile.asset_preservation_value !== null &&
    bfile.asset_preservation_value !== ""
  ) {
    let asset_401k_accounts = [];

    try {
      if (bfile.asset_401k_accounts) {
        // Ensure it's a string before parsing
        asset_401k_accounts = typeof bfile.asset_401k_accounts === "string"
          ? JSON.parse(bfile.asset_401k_accounts)
          : bfile.asset_401k_accounts;
      }
    } catch (error) {
      console.error("Error parsing asset_401k_accounts:", error);
      asset_401k_accounts = [];
    }

    F.log("bfile.asset_401k_accounts", asset_401k_accounts);

    if (asset_401k_accounts.indexOf("Pension Fund") >= 0) {
      asset_401k_accounts.splice(asset_401k_accounts.indexOf("Pension Fund"));
    }
    if (asset_401k_accounts.length > 0) {
      financial_recommendations_data.push({
        name: (
          <div>
            <img
              src={Icon401K}
              alt={`401K`}
              style={{
                width: 16,
                opacity: 0.6,
                marginRight: 10,
                verticalAlign: "middle"
              }}
            />
            {asset_401k_accounts.join(" & ")}
          </div>
        ),
        value: <Translate text={`Re-balance / Diversification Conversation`} />
      });
    }
  }

  //spouse section
  if (
    bfile.asset_401k_accounts_spouse !== "" &&
    bfile.asset_preservation_value_spouse !== null &&
    bfile.asset_preservation_value_spouse !== ""
  ) {

    let asset_401k_accounts_spouse = [];

    if (bfile.asset_401k_accounts_spouse) {
      try {
        asset_401k_accounts_spouse = JSON.parse(bfile.asset_401k_accounts_spouse);
      } catch (error) {
        console.error("Invalid JSON:", bfile.asset_401k_accounts_spouse);
        asset_401k_accounts_spouse = []; // Default to empty array in case of JSON error
      }
    }

    if (Array.isArray(asset_401k_accounts_spouse)) {
      const index = asset_401k_accounts_spouse.indexOf("Pension Fund");
      if (index >= 0) {
        asset_401k_accounts_spouse.splice(index, 1);
      }
    }

    if (asset_401k_accounts_spouse.length > 0) {
      financial_recommendations_data.push({
        name: (
          <div>
            <img
              src={Icon401K}
              alt={`401K`}
              style={{
                width: 16,
                opacity: 0.6,
                marginRight: 10,
                verticalAlign: "middle"
              }}
            />
            {`Spouse - ` + asset_401k_accounts_spouse.join(" & ")}
          </div>
        ),
        value: <Translate text={`Re-balance / Diversification Conversation`} />
      });
    }
  }

  if (
    bfile.asset_401k_accounts !== "" &&
    bfile.asset_preservation_value !== null &&
    bfile.asset_preservation_value !== ""
  ) {
    let asset_401k_accounts = [];

    if (bfile.asset_401k_accounts) {
      try {
        asset_401k_accounts = JSON.parse(bfile.asset_401k_accounts);
      } catch (error) {
        console.error("Invalid JSON:", bfile.asset_401k_accounts);
        asset_401k_accounts = []; // Default to empty array in case of JSON error
      }
    }


    if (Array.isArray(asset_401k_accounts)) {
      const index = asset_401k_accounts.indexOf("Pension Fund");
      financial_recommendations_data.push({
        name: (
          <div>
            <img
              src={IconPensionFund}
              alt={`401K`}
              style={{
                width: 16,
                opacity: 0.6,
                marginRight: 10,
                verticalAlign: "middle"
              }}
            />
            Pension Fund
          </div>
        ),
        value: <Translate text={`Retirement Conversation`} />
      });
    }
  }

  //spouse section
  if (
    bfile.asset_401k_accounts_spouse !== "" &&
    bfile.asset_preservation_value_spouse !== null &&
    bfile.asset_preservation_value_spouse !== ""
  ) {
    let asset_401k_accounts_spouse = [];

    if (bfile.asset_401k_accounts_spouse) {
      try {
        asset_401k_accounts_spouse = JSON.parse(bfile.asset_401k_accounts_spouse);
      } catch (error) {
        console.error("Invalid JSON:", bfile.asset_401k_accounts_spouse);
        asset_401k_accounts_spouse = []; // Default to empty array in case of JSON error
      }
    }


    if (Array.isArray(asset_401k_accounts_spouse)) {
      const index = asset_401k_accounts_spouse.indexOf("Pension Fund"); financial_recommendations_data.push({
        name: (
          <div>
            <img
              src={IconPensionFund}
              alt={`401K`}
              style={{
                width: 16,
                opacity: 0.6,
                marginRight: 10,
                verticalAlign: "middle"
              }}
            />
            Pension Fund
          </div>
        ),
        value: <Translate text={`Retirement Conversation`} />
      });
    }
  }

  if (bfile.asset_accounts_obj.indexOf("IRA's") >= 0) {
    financial_recommendations_data.push({
      name: (
        <div>
          <img
            src={IRAs}
            alt={`IRA`}
            style={{
              width: 16,
              opacity: 0.6,
              marginRight: 10,
              verticalAlign: "middle"
            }}
          />
          <Translate text={`IRA`} />
        </div>
      ),
      value: <Translate text={`Re-balance / Diversification Conversation`} />
    });
  }

  if (
    bfile.asset_accounts_obj_spouse &&
    bfile.asset_accounts_obj_spouse.indexOf("IRA's") >= 0
  ) {
    financial_recommendations_data.push({
      name: (
        <div>
          <img
            src={IRAs}
            alt={`IRA`}
            style={{
              width: 16,
              opacity: 0.6,
              marginRight: 10,
              verticalAlign: "middle"
            }}
          />
          <Translate text={`Spouse - IRA`} />
        </div>
      ),
      value: <Translate text={`Re-balance / Diversification Conversation`} />
    });
  }

  if (
    bfile.asset_accounts_obj_spouse &&
    bfile.asset_accounts_obj_spouse.indexOf("CD's") >= 0
  ) {
    financial_recommendations_data.push({
      name: (
        <div>
          <img
            src={Icon401K}
            alt={`401K`}
            style={{
              width: 16,
              opacity: 0.6,
              marginRight: 10,
              verticalAlign: "middle"
            }}
          />
          <Translate text={`Spouse - CD's`} />
        </div>
      ),
      value: <Translate text={`Rate Conversation`} />
    });
  }
  if (bfile.business_owner_toggle === "1") {
    employment_data.push({
      name: <Translate text={`Ownership interest in a business`} />,
      value: <Translate text={`Yes`} />
    });
    if (bfile.business_name !== "") {
      employment_data.push({
        name: <Translate text={`Business Name`} />,
        // value: bfile.business_name,
        value: <ReadMore>{bfile.business_name}</ReadMore>
      });
    }
    if (bfile.business_type !== "") {
      employment_data.push({
        name: <Translate text={`Business Type`} />,
        value: bfile.business_type
      });
    }
  }

  //spouse section
  if (bfile.business_owner_spouse_toggle === "1") {
    employment_data.push({
      name: <Translate text={`Ownership interest in a business`} />,
      value: <Translate text={`Yes`} />
    });
    if (bfile.business_name_spouse !== "") {
      employment_data.push({
        name: <Translate text={`Spouse's Business Name`} />,
        // value: bfile.business_name_spouse,
        value: <ReadMore>{bfile.business_name_spouse}</ReadMore>
      });
    }
    if (bfile.business_type_spouse !== "") {
      employment_data.push({
        name: <Translate text={`Spouse's Business Type`} />,
        value: bfile.business_type_spouse
      });
    }
  }

  if (bfile.business_owner_toggle === "0") {
    const empRetiredDisabled =
      bfile.employed_retired_disabled != null &&
        bfile.employed_retired_disabled !== ""
        ? `No (${bfile.employed_retired_disabled})`
        : "No";

    let is_employed = empRetiredDisabled;

    if (
      bfile.employed_retired_disabled !== null &&
      bfile.employed_retired_disabled !== "" &&
      bfile.employed_retired_disabled === "Unemployed"
    ) {
      is_employed = "Unemployed";
    }
    if (
      bfile.employed_toggle === "0" &&
      (bfile.employed_retired_disabled === null ||
        bfile.employed_retired_disabled === "")
    ) {
      is_employed = "Homemaker";
    }
    employment_data.push({
      name: <Translate text={`Employed`} />,
      value: (
        <div>
          {bfile.employed_toggle === "1" ? (
            <Translate text={`Yes`} />
          ) : (
            <Translate text={is_employed} />
          )}
        </div>
      )
    });
    if (bfile.employed_toggle === "1" && bfile.employer_name !== "") {
      employment_data.push({
        name: <Translate text={`Employer Name`} />,
        value: bfile.employer_name
      });
    }
    if (bfile.employed_toggle === "1" && bfile.employer_years !== "") {
      const employer_years_options = {
        "Under 1 Year": "Under 1 Year",
        "1 to 5": "1 to 5 years",
        "5 to 10": "5 to 10 years",
        "10 +": "10+ years"
      };

      if (bfile.employer_years in employer_years_options) {
        bfile.employer_years = employer_years_options[bfile.employer_years];
      }

      employment_data.push({
        name: <Translate text={`Worked there`} />,
        value: bfile.employer_years
      });
    }
  }

  //spouse section
  if (bfile.business_owner_spouse_toggle === "0") {
    const empRetiredDisabledSpouse =
      bfile.employed_retired_disabled_spouse != null &&
        bfile.employed_retired_disabled_spouse !== ""
        ? `No (${bfile.employed_retired_disabled_spouse})`
        : "No";

    let is_employed = empRetiredDisabledSpouse;

    if (
      bfile.employed_retired_disabled_spouse !== null &&
      bfile.employed_retired_disabled_spouse !== "" &&
      bfile.employed_retired_disabled_spouse === "Unemployed"
    ) {
      is_employed = "Unemployed";
    }
    if (
      bfile.employed_toggle_spouse === "0" &&
      (bfile.employed_retired_disabled_spouse === null ||
        bfile.employed_retired_disabled_spouse === "")
    ) {
      is_employed = "Homemaker";
    }
    employment_data.push({
      name: <Translate text={`Employed Spouse`} />,
      value: (
        <div>
          {bfile.employed_toggle_spouse === "1" ? (
            <Translate text={`Yes`} />
          ) : (
            <Translate text={is_employed} />
          )}
        </div>
      )
    });

    // if (bfile.employed_toggle === "1" && bfile.employer_name !== "") {
    //   employment_data.push({
    //     name: <Translate text={`Employer Name`} />,
    //     value: bfile.employer_name
    //   });
    // }

    if (
      bfile.employed_toggle_spouse === "1" &&
      bfile.employer_name_spouse !== ""
    ) {
      employment_data.push({
        name: <Translate text={`Spouse's Employer Name`} />,
        value: bfile.employer_name_spouse
      });
    }

    // if (bfile.employed_toggle === "1" && bfile.employer_years !== "") {
    //   const employer_years_options = {
    //     "Under 1 Year": "Under 1 Year",
    //     "1 to 5": "1 to 5 years",
    //     "5 to 10": "5 to 10 years",
    //     "10 +": "10+ years"
    //   };

    //   if (bfile.employer_years in employer_years_options) {
    //     bfile.employer_years = employer_years_options[bfile.employer_years];
    //   }

    //   employment_data.push({
    //     name: <Translate text={`Worked there`} />,
    //     value: bfile.employer_years
    //   });
    // }

    //spouse section
    if (
      bfile.employed_toggle_spouse === "1" &&
      bfile.employer_years_spouse !== ""
    ) {
      const employer_years_options = {
        "Under 1 Year": "Under 1 Year",
        "1 to 5": "1 to 5 years",
        "5 to 10": "5 to 10 years",
        "10 +": "10+ years"
      };

      if (bfile.employer_years_spouse in employer_years_options) {
        bfile.employer_years_spouse =
          employer_years_options[bfile.employer_years_spouse];
      }

      employment_data.push({
        name: <Translate text={`Spouse Worked there`} />,
        value: bfile.employer_years_spouse
      });
    }
  }

  const minimumLiabilityLimits = parseLiabilityLimits(
    bfile.minimum_liability_limits_ext ||
    (bfile.user && bfile.user.minimum_liability_limits_ext) ||
    (agency_owner_details && agency_owner_details.minimum_liability_limits_ext)
  );
  const householdAssets = bfile.rac_calculator || bfile.liability_calculator_value;
  const liabilityCalculationData = {
    carrier:
      bfile.carrier ||
      (agency_owner_details && agency_owner_details.carrier) ||
      (bfile.user && bfile.user.carrier),
    minimum_liability_limits:
      bfile.minimum_liability_limits ||
      (agency_owner_details && agency_owner_details.minimum_liability_limits) ||
      (bfile.user && bfile.user.minimum_liability_limits),
    minimum_liability_limits_ext: minimumLiabilityLimits
  };
  const calculatedAutoAndHome = getAutoAndHomeValue(
    liabilityCalculationData,
    Number(String(householdAssets || 0).replace(/[$,]/g, "")),
    bfile.home_toggle
  );
  const autoLimit =
    bfile.auto_policy_recommended_limit ||
    calculatedAutoAndHome.recommended_limit ||
    minimumLiabilityLimits.Auto;
  const homeLimit =
    bfile.home_policy_recommended_limit_2 ||
    calculatedAutoAndHome.recommended_limit_2 ||
    minimumLiabilityLimits.Home;
  const hasHouseholdAssets =
    householdAssets !== null &&
    householdAssets !== undefined &&
    householdAssets !== "";
  const umbrellaLimit = hasHouseholdAssets
    ? calculateRecommendedUmbrellaLimit(householdAssets)
    : bfile.umbrella_limit;
  const directSuggestedLifeInsurance = bfile.suggested_minimum_life_insurance;
  const configuredLifeMultiplier = directSuggestedLifeInsurance &&
    String(directSuggestedLifeInsurance).toLowerCase().endsWith("x")
    ? directSuggestedLifeInsurance
    : minimumLiabilityLimits["Suggested Minimum Life Insurance"];
  const lifeInsuranceLimits = {
    ...minimumLiabilityLimits,
    "Suggested Minimum Life Insurance": configuredLifeMultiplier
  };
  const suggestedLifeInsurance = directSuggestedLifeInsurance &&
    !String(directSuggestedLifeInsurance).toLowerCase().endsWith("x")
    ? directSuggestedLifeInsurance
    : configuredLifeMultiplier
      ? F.lifeInsurance(bfile, lifeInsuranceLimits)
      : null;

  const isValidValue = (v) => v && v !== "$NaN";
  if (
    isValidValue(householdAssets) || isValidValue(autoLimit) || isValidValue(homeLimit) ||
    isValidValue(umbrellaLimit) || isValidValue(suggestedLifeInsurance)
  ) {
    if (isValidValue(householdAssets)) {
      household_total_assets_data.push({
        key: "household-assets",
        isPrimary: true,
        name: (
          <div className="profile-liability-title profile-liability-title-with-icon profile-household-aligned-title">
            <img src={HomeIcon} className="title-img-width" style={{ width: 30, height: 30 }} />
            <span className="profile-household-title-text profile-household-life-title">
              <span><Translate text={`Household`} /></span>
              <span><Translate text={`Total Assets`} /></span>
            </span>
            {/* <span className="profile-household-title-text">
              <Translate text={`Household Total Assets`} />
            </span> */}
          </div>
        ),
        value: (
          <span style={{ fontSize: "25px", fontWeight: 600 }}>
            {F.dollar_format(householdAssets)}
          </span>
        )
      });
    }
    if (isValidValue(autoLimit) || isValidValue(homeLimit)) {
      household_total_assets_data.push({
        key: "auto-home-limit",
        name: (
          <div className="profile-liability-title profile-liability-title-with-icon profile-household-aligned-title">
            <img src={garageIcon} className="title-img-width" style={{ width: 38, height: 40 }} />
            <span className="profile-household-title-text profile-household-life-title">
              <span><Translate text={`Auto & Home`} /></span>
              <span><Translate text={`Limit`} /></span>
            </span>
          </div>
          // <div className="profile-liability-title">
          //   <Translate text={`Auto & Home Limit`} />
          // </div>
        ),
        value: (
          <div className="profile-liability-limit-pair">
            {isValidValue(autoLimit) && (
              <div className="profile-liability-limit-row">
                <span className="profile-liability-limit-label">
                  <img src={ClassicCarNew} alt="" />
                  <strong style={{ color: "#8a8a8ae5", fontWeight: 500 }}><Translate text={`Auto`} /></strong>
                </span>
                <span>{formatCoverageLimit(autoLimit)}</span>
              </div>
            )}
            {isValidValue(homeLimit) && (
              <div className="profile-liability-limit-row">
                <span className="profile-liability-limit-label">
                  <img src={SecondaryHomeBlue} alt="" />
                  <strong style={{ color: "#8a8a8ae5", fontWeight: 500 }}><Translate text={`Home`} /></strong>
                </span>
                <span>{formatCoverageLimit(homeLimit)}</span>
              </div>
            )}
          </div>
        )
      });
    }
    if (isValidValue(umbrellaLimit)) {
      household_total_assets_data.push({
        key: "umbrella-limit",
        name: (
          <div className="profile-liability-title profile-liability-title-with-icon profile-household-aligned-title">
            <img src={UmbrellaLimitIcon} alt="" style={{ width: 25 }} />
            {/* <span className="profile-household-title-text"> */}
            <span className="profile-household-title-text profile-household-life-title">
              <span><Translate text={`Recommended`} /></span>
              <span><Translate text={`Umbrella Limit`} /></span>
            </span>
            {/* <Translate text={`Recommended Umbrella Limit`} />
            </span> */}
          </div>
        ),
        value: (
          <div className="profile-liability-icon-value">
            <span style={{ fontSize: "25px", fontWeight: 600 }}>
              {F.dollar_format(umbrellaLimit)}
            </span>
          </div>
        )
      });
    }
    if (isValidValue(suggestedLifeInsurance)) {
      household_total_assets_data.push({
        key: "suggested-life-insurance",
        name: (
          <div className="profile-liability-title profile-liability-title-with-icon profile-household-aligned-title">
            <img src={LifeInsuranceIcon} alt="" style={{ width: 25 }} />
            <span className="profile-household-title-text profile-household-life-title">
              <span><Translate text={`Suggested Minimum`} /></span>
              <span><Translate text={`Life Insurance`} /></span>
            </span>
            <Tooltip
              placement="topRight"
              trigger={["hover", "focus"]}
              title={
                <span style={{ fontWeight: 500 }}>
                  (Primary mortgage + Secondary Mortgage) +
                  (# of kids × $100,000) +
                  (Income × {configuredLifeMultiplier || "3x"})
                </span>
              }
            >
              <Icon
                type="info-circle"
                tabIndex={0}
                aria-label="Life insurance formula"
                style={{ marginLeft: "-10px", color: "black", cursor: "help", marginTop: '20px' }}
              />
            </Tooltip>
          </div>
        ),
        value: (
          <div className="profile-liability-icon-value">
            <span style={{ fontSize: "25px", fontWeight: 600 }}>
              {F.dollar_format(suggestedLifeInsurance)}
            </span>
          </div>
        )
      });
    }
  }

  let items_sold = [];
  let cross_sell_opportunities = [];

  // if (bfile.auto_sold_toggle === "1") {
  //   items_sold.push({ name: "Auto", icon: Auto });
  // } else if (bfile.auto_sold_toggle === "0" || bfile.auto_sold_toggle === "2") {
  //   cross_sell_opportunities.push({ name: "Auto", icon: Auto });
  // }

  // if (bfile.home_sold_toggle === "1") {
  //   items_sold.push({ name: "Home", icon: Home });
  // } else if (bfile.home_sold_toggle === "0" || bfile.home_sold_toggle === "2") {
  //   cross_sell_opportunities.push({ name: "Home", icon: Home });
  // }

  // if (
  //   ((bfile.primary_vehicles_toggle !== null ||
  //     bfile.primary_vehicles_toggle !== 0) &&
  //     bfile.primary_vehicles_num !== null) ||
  //   bfile.primary_vehicles_num !== 0
  // ) {
  //   cross_sell_opportunities.push({ name: "Auto", icon: Auto });
  // }
  if (bfile.primary_vehicles_toggle === "1" && bfile.primary_vehicles_num > 0) {
    cross_sell_opportunities.push({
      name: "Auto",
      icon: Auto
    });
  }

  if (bfile.home_toggle === "1") {
    cross_sell_opportunities.push({
      name: "Home",
      icon: Home
    });
  }
  let icon = null;
  bfile.products_sold = [];
  F.log(bfile.financial_conversion.length);
  if (bfile.financial_conversion.length > 0) {
    if (bfile.financial_conversion[0].appointment_status === "Complete Sold") {
      var products_sold = bfile.financial_conversion[0].products_sold;
      var json = [];
      if (
        products_sold !== "" &&
        products_sold !== 0 &&
        products_sold !== null
      ) {
        json = JSON.parse(products_sold);
      }
      bfile.products_sold = json;
      for (let i = 0, len = json.length; i < len; i++) {
        if (json[i].product_sold !== "") {
          var product_sold = json[i].product_sold;
          icon = Insurance;
          if (product_sold === "Annuity") {
            icon = Annuity;
          }
          if (product_sold === "Mutual Funds") {
            icon = MutualFunds;
          }
          items_sold.push({
            name: product_sold,
            icon: icon
          });
        }
      }
    }
  }

  // if (bfile.secondary_vehicles_toggle === "1") {
  //   F.log("00", bfile.secondary_vehicles);
  //   let item = null;
  //   for (let i = 0, len = bfile.secondary_vehicles_toggle.length; i < len; i++) {

  //   }
  // }
  let item = null;
  for (let i = 0, len = bfile.policies.length; i < len; i++) {
    F.log(bfile.policies.length);
    item = bfile.policies[i].policy_type;
    if (item === "Classic Car") icon = ClassicCar;
    if (item === "RV") icon = RV;
    if (item === "Boat") icon = Boat;
    if (item === "Motorcycle") icon = Motorcycle;
    if (item === "Drone") icon = Drone;
    if (item === "Golf Cart") icon = GolfCart;
    if (item === "Water Craft") icon = Watercraft;
    if (item === "Watercraft") icon = Watercraft;
    if (item === "Snowmobile") icon = Snowmobile;
    if (item === "ATV") icon = OffRoad;
    if (item === "Off Road") icon = OffRoad;
    if (item === "Other") icon = Other;
    if (item === "Others") icon = Other;
    // if (item === "Rent") icon = SecondaryHome;
    if (item === "Secondary Home") icon = SecondaryHome;
    if (item === "MFG Home") icon = MFGHome;
    if (item === "Condominium") icon = Condominium;
    if (item === "Landlord") icon = Landlord;
    if (item === "Rentals") icon = MFGHome;
    if (item === "Vacant Property") icon = VacantProperty;
    if (item === "Umbrella") icon = Umbrella;
    // F.log(cross_sell_opportunities.length);
    if (bfile.policies[i].policy_sold !== 1) {
      cross_sell_opportunities.push({
        name: item,
        icon: icon
      });
      F.log(cross_sell_opportunities, "cross_sell_opportunities.length");
    }

    if (bfile.policies[i].policy_sold === 1) {
      items_sold.push({ name: item, icon: icon });
      F.log(cross_sell_opportunities.length);
    }
  }
  // let name = null;
  // if (bfile.secondary_vehicles) {
  //   const secondary_vehicles = JSON.parse(bfile.secondary_vehicles);
  //   if (secondary_vehicles) {
  //     for (let i = 0, len = secondary_vehicles.length; i < len; i++) {
  //       item = secondary_vehicles[i];
  //       icon = null;
  //       if (item === "Classic Car") icon = ClassicCar;
  //       if (item === "RV") icon = RV;
  //       if (item === "Boat") icon = Boat;
  //       if (item === "Motorcycle") icon = Motorcycle;
  //       if (item === "Drone") icon = Drone;
  //       if (item === "Golf Cart") icon = GolfCart;
  //       if (item === "Watercraft") icon = Watercraft;
  //       if (item === "Snowmobile") icon = Snowmobile;
  //       if (item === "Off Road") icon = OffRoad;
  //       cross_sell_opportunities.push({ name: item, icon: icon });
  //     }
  //   }
  // }
  // let item = null;
  if (bfile.home_toggle === "2") {
    cross_sell_opportunities.push({
      name: "Rent",
      icon: SecondaryHome
    });
  }
  // if (bfile.secondary_home_type) {
  //   const secondary_home_type = JSON.parse(bfile.secondary_home_type);
  //   if (secondary_home_type) {
  //     for (let i = 0, len = secondary_home_type.length; i < len; i++) {
  //       item = secondary_home_type[i];
  //       icon = null;
  //       if (item === "Secondary Home") icon = SecondaryHome;
  //       if (item === "MFG Home") icon = MFGHome;
  //       if (item === "Renter") icon = Renter;
  //       if (item === "Condominium") icon = Condominium;
  //       if (item === "Landlord") icon = Landlord;
  //       if (item === "Vacant Property") icon = VacantProperty;
  //       cross_sell_opportunities.push({ name: item, icon: icon });
  //     }
  //   }
  // }

  for (let i = 0, len = cross_sell_opportunities.length; i < len; i++) {
    item = cross_sell_opportunities[i];
    F.log(cross_sell_opportunities.length);
    const isAuto = item.name && item.name.toLowerCase() === "auto";
    pc_cross_sell_opp_data.push({
      name: "",
      value: (
        <span className="">
          <span>
            <img
              src={item.icon}
              alt={item.name}
              style={{
                width: 20,
                opacity: 0.6,
                marginRight: 10,
                verticalAlign: "middle"
              }}
            />
          </span>
          <span>
            <Translate text={item.name ? item.name : ""} />
            {isAuto && bfile.primary_vehicles_num ? (
              <strong> X{bfile.primary_vehicles_num}</strong>
            ) : null}
          </span>
        </span>
      )
    });
    console.log("cross_sell_opportunities.length", cross_sell_opportunities);
  }

  for (let i = 0, len = items_sold.length; i < len; i++) {
    F.log(items_sold.length);
    item = items_sold[i];
    items_sold_data.push({
      name: (
        <div>
          <img
            src={item.icon}
            alt={item.name}
            style={{
              width: 20,
              opacity: 0.6,
              marginRight: 10,
              verticalAlign: "middle"
            }}
          />
          <Translate text={item.name ? item.name : ""} />
        </div>
      ),
      value: ""
    });
  }

  if (bfile.auto_sold_toggle === "1") {
    renewal_policies_data.push({
      name: <Translate text={`Auto`} />,
      value: F.bfile_renewal_date(
        bfile.auto_policy_sold_effective_date,
        bfile.auto_policy_sold_term
      )
    });
  }
  {
    F.log("121", life_stage_data);
  }

  // if (bfile.home_sold_toggle === "1") {
  //   renewal_policies_data.push({
  //     name: <Translate text={`Home`} />,
  //     value: F.bfile_renewal_date(
  //       bfile.home_policy_sold_effective_date,
  //       bfile.home_policy_sold_term
  //     ),
  //   });
  // }

  // if (assets_account_data) {
  //   for (let [key, value] of Object.entries(assets_account_data)) {
  //     console.log(" NOOR Code  "+key, value);
  //   }
  // }

  // new work adding for hiding `Assets Accounts` if doesn't have data --> `BMG-365`
  const notHaveAssets =
    bfile.asset_accounts_obj.length === 0 ||
    (bfile.asset_accounts_obj.length === 1 &&
      bfile.asset_accounts_obj.indexOf("None") >= 0);

  const notHaveSpouseAssets =
    bfile.asset_accounts_obj_spouse.length === 0 ||
    (bfile.asset_accounts_obj_spouse.length === 1 &&
      bfile.asset_accounts_obj_spouse.indexOf("None") >= 0);

  //  this is where we making sequence which comes first 
  const assetsAccountsContainer =
    assets_account_data.length == 2 && notHaveAssets && notHaveSpouseAssets
      ? { data: [] }
      : {
        id: "card_asset_accounts",
        // title: (
        //   <Translate text={`Asset Accounts / Retirement Opportunities`} />
        // ),
        title: (<span className="card-icon-title-container">
          <img src={financialIcon} className="title-img-width" />  <Translate text={`Asset Accounts / Retirement Opportunities`} />
        </span>),
        data: assets_account_data
      };

  return [

    {
      id: "card_household",
      title: <Translate text={`Household Total Assets`} />,
      data: household_total_assets_data
    },
    {
      id: "card_cross_sell_opp",
      title: (<span>
        <img src={garageIcon} />  <Translate text={`P&C Items IN The Household`} />
      </span>),
      data: pc_cross_sell_opp_data
    },
    {
      id: "card_life_stage",
      // title: <Translate text={`Life Stage`} />,
      title: (<span className="card-icon-title-container">
        <img src={processIcon} className="title-img-width" />  <Translate text={`Life Stage`} />
      </span>),
      data: life_stage_data
    },

    // Hide this code for implementing `BMG-365`
    // {
    //   id: "card_asset_accounts",
    //   title: <Translate text={`Asset Accounts / Retirement Opportunities`} />,
    //   data: assets_account_data,
    // },
    {
      id: "card_employment",
      // title: <Translate text={`Employment`} />,
      title: (<span className="card-icon-title-container">
        <img src={workerIcon} className="title-img-width" />  <Translate text={`Employment / Business Owner`} />
      </span>),
      data: employment_data
    },
    assetsAccountsContainer,
    {
      id: "card_financial_rec",
      title: (<span className="card-icon-title-container" >
        <img src={moneyBagIcon} className="title-img-width" />  <Translate text={`B File Financial Recommendations`} />
      </span>),
      data: financial_recommendations_data
    },
    {
      id: "card_status",
      title: (<span className="card-icon-title-container">
        <img src={NotePadIcon} className="title-img-width" />  <Translate text={`Status`} />
      </span>),
      data: status_data
    }
    // {
    //   id: "card_items_sold",
    //   title: <Translate text={`Items Sold`} />,
    //   data: items_sold_data,
    // },
    // {
    //   id: "card_renewal_policies",
    //   title: <Translate text={`Renewal Policies`} />,
    //   data: renewal_policies_data,
    // },
  ];
};

export default init;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/init.js